export function parseTime(time: string): Date {
  let date = new Date(time);
  return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
}
